import React from "react";
import { motion } from "framer-motion";
import { ChevronRightIcon } from "@heroicons/react/20/solid";

// Hook to detect if screen is large (lg breakpoint)
function useIsLargeScreen() {
  const [isLarge, setIsLarge] = React.useState(
    typeof window !== "undefined" ? window.innerWidth >= 1024 : false
  );
  React.useEffect(() => {
    function handleResize() {
      setIsLarge(window.innerWidth >= 1024);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isLarge;
}

const ImageText2 = ({
  imageUrl,
  heading,
  text,
  buttonText,
  buttonLink,
  backgroundColor = "#284B5A",
  textColor = "#fff",
  buttonColor = "#fff",
  buttonTextColor = "#284B5A",
  logoUrl,
}) => {
  const isLarge = useIsLargeScreen();

  // Responsive animation direction
  const imageInitial = isLarge
    ? { x: -100, opacity: 0 }
    : { y: 40, opacity: 0 };
  const textInitial = isLarge ? { x: 100, opacity: 0 } : { y: 40, opacity: 0 };
  const animate = { x: 0, y: 0, opacity: 1 };

  return (
    <div style={{ backgroundColor }}>
      <div
        className="mx-auto py-12 px-4 sm:px-6 lg:px-8"
        style={{ maxWidth: "1310px" }}
      >
        <div className="flex flex-col lg:flex-row items-center space-y-6 lg:space-y-0 lg:space-x-12">
          <motion.div
            className="w-full lg:w-1/2"
            initial={imageInitial}
            whileInView={animate}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
          >
            <img src={imageUrl} alt="placeholder" className="w-full h-auto" />
          </motion.div>
          <motion.div
            className="w-full lg:w-2/3"
            initial={textInitial}
            whileInView={animate}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
          >
            <h2
              className="text-3xl lg:text-3xl font-semibold mb-4"
              style={{ color: textColor, fontWeight: "bold" }}
            >
              {heading}
            </h2>
            <p className="text-lg lg:text-lg" style={{ color: textColor }}>
              {text}
            </p>
            {buttonText && (
              <a
                href={buttonLink}
                className="inline-flex items-center no-underline mt-1 px-6 py-1 text-lg font-semibold rounded-lg shadow-md"
                style={{ color: buttonTextColor, backgroundColor: buttonColor }}
              >
                {buttonText}
                <ChevronRightIcon
                  className="ml-2 w-5 h-5"
                  style={{ color: buttonTextColor }}
                />
              </a>
            )}
            {logoUrl && (
              <div className="mt-4">
                <img src={logoUrl} alt="logo" className="w-[360px] h-auto" />
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ImageText2;
